import { render, staticRenderFns } from "./PPSCallBack.vue?vue&type=template&id=7c74a6f0"
import script from "./PPSCallBack.vue?vue&type=script&lang=js"
export * from "./PPSCallBack.vue?vue&type=script&lang=js"
import style0 from "./PPSCallBack.vue?vue&type=style&index=0&id=7c74a6f0&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports